import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import SalesReportService from "../../../Services/QRCodeServices/ReportServices/SalesReportService";

const SalesReportDetail = ({ isOpen, toggle, selectedItem }) => {
  console.log("🚀 ~ SalesReportDetail ~ selectedItem:", selectedItem);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const orgInfo = user?.organizationInfo || {};
  const [responseData, setResponseData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await SalesReportService.getSalesDetail(
        selectedItem?.orderReferenceId
      );
      setResponseData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [selectedItem?.orderReferenceId]);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody style={{ fontFamily: "monospace" }}>
        <div className="p-3">
          {/* Bill Header */}
          <div className="text-center mb-4">
            <h5 className="fw-bold text-uppercase mb-0 ">
              {orgInfo?.name || "Company Name"}
            </h5>
            <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
            <div>{orgInfo?.tel || "000-0000000"}</div>
          </div>
          <div className="d-flex justify-content-between small mb-3">
            <div>
              <strong>Order Ref:</strong> {responseData?.itemAmount || ""}
            </div>
            <div>
              <strong>Status:</strong> {responseData?.billingStatus}
            </div>
          </div>

          {/* Order Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th className="text-end">Price</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {responseData?.menuOrderDetails?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item?.menuItemDetail?.title}</td>
                  <td className="text-end">{item?.price}</td>
                  <td className="text-center">{item?.quantity}</td>
                  <td className="text-end">{item?.itemPrice + item?.vatAmount}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Bill Footer */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <span>Subtotal</span>
              <span>{responseData?.itemAmount}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Discount</span>
              <span>{responseData?.discountAmount}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>{responseData?.taxAmount}</span>
            </div>
            <hr className="m-1" />
            <div className="d-flex justify-content-between fw-bold">
              <span>Grand Total</span>
              <span>{responseData?.finalAmount}</span>
            </div>
          </div>
        </div>
        <div className="small mt-2">
          <div className="text-center mt-2">**Thank You**</div>
          <div className="text-center text-muted small">Powered by SEBS</div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SalesReportDetail;
